import { queryVendor } from "./queries/queryVendor"
import { queryVendors } from "./queries/queryVendors"
import { typeVendors } from "./vendors"

const vendorSchema = {
  types: [typeVendors],
  resolvers: {
    Query: { ...queryVendor, ...queryVendors },
    Mutation: {},
  },
}

export default vendorSchema
